import api from "./axios";

export async function getJiraProjects(){
    try {
        const { data } = await api.get("/jira/projects");
        return Array.isArray(data?.values) ? data.values : [];
    } catch (err) {
        console.error("getJiraProjects failed:", err);
        return [];
    }
}

export async function getJiraProjectById(id: string){
    try {
        if (!id) return [];
        const { data } = await api.get(`/jira/project/${id}`);
        if (Array.isArray(data)) return data;
        if (Array.isArray(data?.issues)) return data.issues;
        return [];
    } catch (err) {
        console.error("getJiraProjectById failed:", err);
        return [];
    }
}

export async function SyncJiraTasks(){
    const { data } = await api.get('/jira/sync/tasks')
    return data
}

export async function SyncChangelogsTasks(){
    const { data } = await api.get('/jira/sync/changelogs')
    return data
}
